module.exports = __webpack_public_path__ + "static/media/menuListxlsx.8c278ba0.xlsx";